import { Injectable } from '@angular/core';
import { BaseController, Params } from '@app/common/modules/base/base.controller';
import { InspecaoRepository } from '@app/data/inspecoes/inspecao.repository';
import { InspecaoModel } from '@app/data/inspecoes/models';
import { Observable, map } from 'rxjs';

export const InspecaoStatusMap: Record<number | string, string> = {
  1: 'Aberto',
  2: 'Em Assinatura',
  3: 'Assinado',
  4: 'Cancelado',
};

@Injectable()
export class InspecaoController extends BaseController<InspecaoModel> {
  constructor(inspecaoRepository: InspecaoRepository) {
    super(inspecaoRepository);
  }

  override getPaginated(
    params: Params,
  ): Observable<{ data: { results: InspecaoModel[]; count: number } }> {
    const queryParams: any = {
      page: params.page,
      limit: params.limit,
      offset: params.offset,
    };

    if (params.search) {
      const pairs = params.search.split('&');
      for (const pair of pairs) {
        const [k, v] = pair.split('=');
        if (k && v !== undefined) {
          queryParams[k.trim()] = decodeURIComponent(v.trim());
        }
      }
    }

    return this.repository
      .getRequest<{ data: { results: InspecaoModel[]; count: number } }>(queryParams)
      .pipe(
        map((response) => {
          if (response?.data?.results) {
            response.data.results = response.data.results.map((item) => {
              const statusDesc =
                InspecaoStatusMap[item.CodigoInspecaoStatus] ||
                InspecaoStatusMap[item.CodigoStatus as any] ||
                'Aberto';

              return {
                ...item,
                numeroInspecao: item.NumeroInspecao,
                categoriaInspecao: item.TipoInspecaoChecklist?.Descricao || '-',
                empresa: item.Empresa?.Pessoa?.RazaoSocial || '-',
                placa: item.Veiculo?.Placa || '-',
                veiculoStatus: item.VeiculoStatus?.Descricao || '-',
                checklistStatus: statusDesc,
                dataHoraInspecao: item.InseridoEm,
              };
            });
          }
          return response;
        }),
      );
  }
}
